export default {
  countries: [],
  cities: [],
  isSelectCountry: true,
  country: { 
    "id": 2,
    "name": "colombia",
    "country_code": "co",
    "language": "es-CO",
    "currency": "COP"
  }
}
